import { filterConfiguration } from 'app/components/filters/filters-panel/filter-configuration';
import { endpoint } from 'app/area/filters/constants';
import { FilterTypes } from 'app/components/filters/types';
import { postfixOperator } from 'app/components/filters/filters-panel/constants';
import { FilterPredefinedFilters } from './filter-predefined-filters';

export const predefinedFiltersConfiguration = {
  [FilterTypes.PredefFilters]: filterConfiguration(
    FilterPredefinedFilters,
    () => endpoint.predefinedFilters,
    [postfixOperator.include, postfixOperator.exclude]
  )
};
